import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";
import Hoot from "./Hoot";

function PrivateRoute({ children }) {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        await axios.get(Hoot()+"me", { withCredentials: true });
        setAuthenticated(true);
      } catch (error) {
        setAuthenticated(false);
        console.clear()
        console.log(error)
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) return <p>Carregando...</p>;

  return authenticated ? children : <Navigate to="/login" />;
}

export default PrivateRoute;
